// React
import React from "react"
import { graphql, useStaticQuery } from "gatsby"

// Components
import HeaderBlock from "../components/HeaderBlock"
import HeroImage from "../components/HeroImage/HeroImage"
import EventsGrid from "../components/EventsGrid"
import BackgroundWrapper from "../components/BackgroundWrapper"
import EventsTable from "../components/EventsTable"
import Seo from "../components/Seo"

// Material UI
import { Container, Typography } from "@mui/material"

function useEventContent() {
  return useStaticQuery(
    graphql`
      query {
        homeData: allContentfulHomePage {
          edges {
            node {
              eventsDescription
              eventsTitle
              eventsHeroImage {
                gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP])
              }
            }
          }
        }
        events: allContentfulEvent(
          filter: {
            sys: { revision: { ne: null } }
            locationReference: { title: { ne: null } }
          }
          sort: { fields: startTime, order: ASC }
        ) {
          edges {
            node {
              slug
              startTime
              endTime
              destinationUrl
              summary {
                summary
              }
              title
              subtitle
              locationReference {
                title
              }
            }
          }
        }
      }
    `
  )
}

function formatContentFulEntries(loc) {
  if (loc) {
    return loc.edges.map((l) => l.node)
  }
  return []
}

export default function LocationsPage() {
  const { events, homeData } = useEventContent()
  const formattedEvents = formatContentFulEntries(events)
  const { eventsDescription, eventsTitle, eventsHeroImage } =
    formatContentFulEntries(homeData)[0]

  // EventCards
  const numberOfEvents = 3 // Only show 3 events on home page
  const eventCards = formattedEvents.slice(0, numberOfEvents)

  // Also limit number of entries in Table?

  return (
    <>
      <Seo
        title="Events"
        description="Events at BounceSpace"
        pathname="/events"
        image={eventsHeroImage.gatsbyImageData.images.fallback.src}
      />

      <HeroImage title={eventsTitle} image={eventsHeroImage.gatsbyImageData} />
      <BackgroundWrapper
        backgroundColor="background.light"
        bottomGutterSpacing={6}
      >
        <Container>
          <HeaderBlock
            title={eventsTitle ? eventsTitle : "Events"}
            titleComponent="h2"
            description={eventsDescription ? eventsDescription : null}
            bottomGutterSpacing={6}
            topGutterSpacing={6}
          />
          <EventsGrid events={eventCards} bottomGutterSpacing={8} />
        </Container>
      </BackgroundWrapper>
      <BackgroundWrapper bottomGutterSpacing={6}>
        <HeaderBlock
          title="Other Events"
          titleComponent="h2"
          bottomGutterSpacing={6}
          topGutterSpacing={6}
        />
        <EventsTable events={formattedEvents} />
      </BackgroundWrapper>
    </>
  )
}
